module.exports = __webpack_public_path__ + "footer-linkedin-extra-small.19I6tfai.svg";